import React, { useEffect, useState } from "react";
import { FileDown, Send, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

const money = (v, c = "USD") => `${c} ${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function StaffPayslips() {
  const [rows, setRows] = useState(null);

  useEffect(() => { api.get("/staff/payroll/payslips").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  const download = async (p) => {
    try { const r = await api.get(`/staff/payroll/payslips/${p.id}/pdf`, { responseType: "blob" }); const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = `payslip-${p.period_label}.pdf`; a.click(); setTimeout(() => URL.revokeObjectURL(u), 60000); }
    catch { toast.error("Payslip unavailable"); }
  };
  const whatsapp = (p) => {
    const text = encodeURIComponent(`My Rose Airbnb payslip for ${p.period_label} — Net pay ${money(p.net_pay, p.currency)}.`);
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };
  const ytd = async () => {
    try { const r = await api.get(`/staff/payroll/statement.pdf`, { responseType: "blob" }); const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = `ytd-statement.pdf`; a.click(); setTimeout(() => URL.revokeObjectURL(u), 60000); }
    catch { toast.error("Statement unavailable"); }
  };

  if (rows === null) return <Loader2 className="animate-spin text-rose mx-auto my-10" />;

  return (
    <div className="p-4" data-testid="staff-payslips">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-serif text-xl text-forest">My payslips</h3>
        <button onClick={ytd} data-testid="staff-ytd" className="text-xs px-3 py-2 rounded-lg bg-sand text-forest font-semibold inline-flex items-center gap-1.5"><FileDown size={14} /> YTD statement</button>
      </div>
      {rows.length === 0 ? (
        <div className="text-center py-14 text-stone-400"><FileText size={28} className="mx-auto mb-3 opacity-50" />No payslips available yet.</div>
      ) : (
        <div className="space-y-3">
          {rows.map((p) => (
            <div key={p.id} className="card-lux p-4" data-testid={`staff-payslip-${p.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-serif text-lg text-forest">{p.period_label}</div>
                  <div className="text-xs text-stone-400">{p.period_start || "—"} → {p.period_end || "—"}</div>
                </div>
                <div className="text-right"><div className="text-xs text-stone-500">Net pay</div><div className="font-serif text-xl text-forest">{money(p.net_pay, p.currency)}</div></div>
              </div>
              <div className="text-xs text-stone-500 mt-2 bg-sand/50 rounded-lg px-3 py-2">Cleaning productivity: {p.productivity?.completed || 0}/{p.productivity?.worksheets || 0} worksheets · {p.productivity?.avg_completion || 0}% avg</div>
              <div className="flex gap-2 mt-3">
                <button onClick={() => download(p)} data-testid={`staff-payslip-download-${p.id}`} className="flex-1 text-xs px-3 py-2 rounded-lg bg-forest text-cream font-semibold inline-flex items-center justify-center gap-1.5"><FileDown size={14} /> Download PDF</button>
                <button onClick={() => whatsapp(p)} className="flex-1 text-xs px-3 py-2 rounded-lg bg-green-600 text-white font-semibold inline-flex items-center justify-center gap-1.5"><Send size={14} /> WhatsApp</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
